<template>
  <v-btn
    class="btn"
    :color="color"
    :disabled="disabled"
    :block="block"
    depressed="depressed"
    :type="type"
    :loading="loading"
    v-bind="$attrs"
    v-on="$on"
    @click.native="onClick($event)"
  >
    <v-icon
      v-if="icon"
      left="left"
    >
      {{ icon }}
    </v-icon><span class="white--text btn--text">{{ text }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'ButtonPrimary',
  props: {
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    iconRight: {
      type: Boolean,
    },
    block: {
      type: Boolean,
    },
    type: {
      type: String,
      default: 'button',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },

};
</script>

<style scoped>
 .v-btn {
    border-radius: 4px;
    padding: 0 14px !important;
  }
  .btn--text {
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.8px;
  }
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: #FFC4C6 !important;
  }
</style>
